import { Box, Flex } from '@chakra-ui/react';
import {
  MultiSelect,
  reactSelectStyles,
  Select,
  Text,
} from '@diamond/shared/ui';
import { statusData } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import {
  useCustomerTypes,
  useDistributionChannel,
} from '@diamond/sol-admin/features/shipto';
import { ReactNode, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import shallow from 'zustand/shallow';

const doAutomationOptions = [
  { label: 'Semua', value: 'all' },
  { label: 'Ya', value: 'true' },
  { label: 'Tidak', value: 'false' },
];

function ActivityFilterField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <Box minW="102px">
      <Text color="#202428" fontSize="10px" fontWeight="medium" mb="1">
        {label}
      </Text>
      {children}
    </Box>
  );
}

export function ActivitiesSmartSearch() {
  const { setValue, watch } = useFormContext();
  const [
    activityStatus,
    category2,
    selectedCustomerTypes,
    setActivityStatus,
    setSelectedCustomerTypes,
  ] = useAuthStore(
    (s) => [
      s.activityStatus,
      s.category2,
      s.selectedCustomerTypes,
      s.setActivityStatus,
      s.setSelectedCustomerTypes,
    ],
    shallow
  );

  const { options: customerTypeOptions } = useCustomerTypes();
  const { data: distributionChannelValues } = useDistributionChannel();

  const distributionChannelOptions = useMemo(() => {
    return [
      { label: 'Semua Distribution Channel', value: '' },
      ...(distributionChannelValues?.data || []).map((dc) => ({
        label: dc.distribution_channel,
        value: dc.distribution_channel,
      })),
    ];
  }, [distributionChannelValues?.data]);

  const statusOptions = useMemo(() => {
    return category2 === '' || category2 === 'semua'
      ? [{ label: 'Semua Status', value: 'semua' }, ...statusData]
      : category2 === 'processed'
      ? [statusData[2]]
      : [statusData[1]];
  }, [category2]);

  const selectedStatus = useMemo(() => {
    return statusOptions.find((it) => it.value === activityStatus);
  }, [activityStatus, statusOptions]);
  const selectedDc = distributionChannelOptions.find(
    (it) => it.value === watch('distribution_channel')
  );
  const selectedDoAutomation = doAutomationOptions.find(
    (it) => it.value === watch('do_automation')
  );
  return (
    <Box maxW="full">
      <Flex
        justifyContent="flex-start"
        alignItems="flex-start"
        wrap="wrap"
        gap={4}
      >
        <ActivityFilterField label="Status">
          <Select
            id="order_status"
            placeholder="Semua"
            options={statusOptions}
            value={selectedStatus ?? null}
            onChange={(val) => {
              const value = val?.value || '';
              setActivityStatus(value);
              setValue('status', value);
            }}
          />
        </ActivityFilterField>
        <ActivityFilterField label="Distribution Channel">
          <Select
            id="distribution_channel"
            placeholder="Semua DC"
            options={distributionChannelOptions}
            value={selectedDc ?? null}
            onChange={(val) => {
              const value = val?.value || '';
              setValue('distribution_channel', value);
            }}
          />
        </ActivityFilterField>
        <ActivityFilterField label="Tipe Customer">
          <MultiSelect
            id="customer_types"
            placeholder="Semua"
            chakraStyles={reactSelectStyles}
            options={customerTypeOptions}
            value={selectedCustomerTypes}
            onChange={(vals) => {
              setSelectedCustomerTypes(vals);
              setValue('customer_types', vals);
            }}
          />
        </ActivityFilterField>
        <ActivityFilterField label="DO Otomatis">
          <Select
            id="do_automation"
            placeholder="DO Otomatis"
            options={doAutomationOptions}
            value={selectedDoAutomation ?? null}
            onChange={(val) => {
              const value = val?.value || 'all';
              setValue('do_automation', value);
            }}
          />
        </ActivityFilterField>
      </Flex>
    </Box>
  );
}
